// extracted by mini-css-extract-plugin
module.exports = {"error":"ConfigSectionInput_error__MOu27"};